import { useTokenData } from "@/hooks/useTokenData";
import MyGoalsQuestionMilestone from "../mygoals/presentation/mygoals-question-milestone";
import { useRouter } from "next/router";
import { notification } from "antd";
import { GoalsContext } from "@/services/GoalsProvider";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { POINT_PROGRESS_INTERVAL_MS } from "@/utils/constants";
import { debounce } from "lodash";
import { useShowModalResult } from "@/components/modal-result";
import useAuthStore from "@/store/useAuthStore";
import { updateProfile, useGetUserProfile } from "@/hooks/useUsers";
import useAuth from "@/hooks/useAuth";
import { IQuickQuest, useGetQuickQuestion } from "@/hooks/useGoals";

function QuickQuestionWidget() {
  const tokenData = useTokenData();
  const {user} = useAuthStore()

  const {
    data: dataUserProfile,
    refetch: refetchDataUserProfile,
    isFetching,
  } = useGetUserProfile(user?.profile?.user_id);

  const router = useRouter();
  const [api, contextHolder] = notification.useNotification();

  const {
    data: dataQuickQuestion,
    refetch: refetchQuickQuestion,
    isFetching: isFetchingQuickQuestion,
    isLoading: isLoadingQuestion,
  } = useGetQuickQuestion();

  useEffect(() => {
    refetchQuickQuestion();
  },[])

  const { successModal } = useShowModalResult();

  const [isLoadingSubmitQuestion, isLoadingSubmitQuestionSet] = useState(false);

  async function onSubmit(value: any, isNested?: string) {
    try {
      const payloadUser = {
        // cognitoID: dataUserProfile?.user?.cognitoID,
        id: dataUserProfile?.user?.id,
        _version: dataUserProfile?.user?._version,
      };
      isLoadingSubmitQuestionSet(true);
      const cloneNFilterNull = Object.fromEntries(
        // @ts-ignore
        Object.entries({ ...dataUserProfile?.user[isNested] } as never).filter(
          ([key, value]) => value !== null,
        ),
      );
      delete cloneNFilterNull.__typename;
      const payloadDt = isNested
        ? {
            [isNested]: {
              ...cloneNFilterNull,
              [dataQuickQuestion?.field as never]: value,
            },
          }
        : {
            [dataQuickQuestion?.type === "departments"
              ? "userDepartmentId"
              : (dataQuickQuestion?.field as string)]: value,
          };

      await updateProfile({
        ...payloadUser,
        ...payloadDt,
        isAskedTwiceAlready: dataQuickQuestion?.isSecondTime ? true : false // ensure that the second confirmation for sensitive question has been asked twice
      });
      isLoadingSubmitQuestionSet(false);
      refetchQuickQuestion();
      refetchDataUserProfile();
    } catch (error: any) {
      api.error({
        message: `failed quick question`,
        description:
          error?.errors[0]?.message ||
          "There was a problem with quick question process, please try again",
      });
      isLoadingSubmitQuestionSet(false);
    }
  }

  const [holdMax, holdMaxSet] = useState<string[]>([]);

  return (
    <div className="w-full">
      <MyGoalsQuestionMilestone
        isPremium={tokenData?.isPremium === "true"}
        onSubmit={onSubmit}
        dataQuickQuestion={dataQuickQuestion || {} as IQuickQuest}
        isFetchingQuickQuestion={isFetchingQuickQuestion}
        isLoadingQuestion={isLoadingQuestion}
        isLoadingSubmitQuestion={isLoadingSubmitQuestion}
        refetchQuickQuestion={refetchQuickQuestion}
        holdMax={holdMax}
        holdMaxSet={holdMaxSet}
        focusedSkill={null}
        isDashboard
      />
    </div>
  );
}

export default QuickQuestionWidget;
